import React from "react";
import { Button, Result } from "antd";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("AppErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return <AppErrorFallback onReset={this.handleReset} />;
  }
}

function AppErrorFallback({ onReset }) {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "#f8fafc",
      }}
    >
      <Result
        status="warning"
        title="Something went wrong"
        subTitle="The page ran into a problem. You can try again or go back to the dashboard."
        extra={[
          <Button type="primary" key="retry" onClick={onReset}>
            Try again
          </Button>,
          <Button key="home" onClick={() => window.location.assign("/dashboard")}>
            Go to Dashboard
          </Button>,
        ]}
      />
    </div>
  );
}

export default AppErrorBoundary;
